import { ApiService } from '@/services/api.service';
import { Config } from '@/config';
import { createGetSSEStream } from '@/util/sse-stream-util';

class AiModulesService {
  /**
   * Trigger an account-profile import from uploaded documents.
   * Returns the created job ({ job_id, status }); progress is streamed via `subscribeToJob`.
   */
  importTenantProfile(files = [], signal = null) {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));

    return ApiService.post(`${Config.api.aiModules.url}api/tenant-profiles/import`, formData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
      signal,
    }).then((response) => response.data);
  }

  /**
   * Fill the given opportunity form documents using a tenant-profile template.
   * Returns the created job ({ job_id, status }); progress is streamed via `subscribeToJob`.
   */
  fillForms({ templateId, opportunityId, documentIds = [], signal = null }) {
    const body = {
      tenant_profile_template_id: templateId,
      opportunity_id: opportunityId,
      document_ids: documentIds,
    };
    return ApiService.post(`${Config.api.aiModules.url}api/documents/fill`, body, { signal }).then(
      (response) => response.data,
    );
  }

  /**
   * Subscribe to a job's events from ai-modules via GET SSE.
   *
   * @returns {{ abort: Function }} Handle to abort the stream.
   */
  subscribeToJob({ jobId, signal = null }, eventCallbacks) {
    const url = `${Config.api.aiModules.url}api/jobs/${jobId}/events`;
    return createGetSSEStream(url, eventCallbacks, { signal });
  }
}

export const aiModulesService = new AiModulesService();
